"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = __importStar(require("react"));
// Global flag to track if CSS has been loaded
var flagIconsCssLoaded = false;
// Function to lazy load the flag-icons CSS
var loadFlagIconsCSS = function () {
    return new Promise(function (resolve) {
        // Check if already loaded
        if (flagIconsCssLoaded) {
            resolve();
            return;
        }
        // Check if link already exists in DOM
        var existingLink = document.querySelector('link[href*="flag-icons"]');
        if (existingLink) {
            flagIconsCssLoaded = true;
            resolve();
            return;
        }
        // Create and append the CSS link
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href =
            'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.5.0/css/flag-icons.min.css';
        link.onload = function () {
            flagIconsCssLoaded = true;
            resolve();
        };
        link.onerror = function () {
            console.warn('Failed to load flag-icons CSS, falling back to text representation');
            flagIconsCssLoaded = true; // Prevent retries
            resolve();
        };
        document.head.appendChild(link);
    });
};
var FlagIcon = react_1.default.memo(function (_a) {
    var countryCode = _a.countryCode, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b;
    var _c = (0, react_1.useState)(flagIconsCssLoaded), cssLoaded = _c[0], setCssLoaded = _c[1];
    (0, react_1.useEffect)(function () {
        var mounted = true;
        if (!cssLoaded && !flagIconsCssLoaded) {
            void loadFlagIconsCSS().then(function () {
                if (mounted) {
                    setCssLoaded(true);
                }
            });
        }
        else if (flagIconsCssLoaded && !cssLoaded) {
            // If CSS was loaded globally but state doesn't reflect it
            setCssLoaded(true);
        }
        return function () {
            mounted = false;
        };
    }, [cssLoaded]);
    // Convert country code to lowercase for flag-icons
    var flagClass = "fi fi-".concat(countryCode.toLowerCase());
    // Show fallback while CSS is loading
    if (!cssLoaded) {
        return ((0, jsx_runtime_1.jsx)("span", { className: className, style: __assign({ fontSize: '16px', lineHeight: 1, display: 'inline-block', width: '20px', height: '15px', backgroundColor: '#f0f0f0', border: '1px solid #ccc', borderRadius: '2px', textAlign: 'center' }, style), "aria-label": "".concat(countryCode, " flag (loading)"), title: "Loading flag..." }));
    }
    return ((0, jsx_runtime_1.jsx)("span", { className: "".concat(flagClass, " ").concat(className), style: __assign({ fontSize: '16px', lineHeight: 1, display: 'inline-block', width: '20px', height: '15px' }, style), "aria-label": "".concat(countryCode, " flag") }));
});
FlagIcon.displayName = 'FlagIcon';
exports.default = FlagIcon;
//# sourceMappingURL=FlagIcon.js.map